
<template>
  <div ref="Dashboardpdf" id="Dashboardpdf">
    <section class="dashboard">
      <div>
         <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
        <!-- <loading
          :active.sync="isLoading"
          loader="spinner"
          color="#36304a"
          :width="70"
        ></loading> -->
      </div>

      <b-card class="mainCardBG" v-if="showDash == true">
        <b-button @click="previousPage" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
        <b-row>
          <b-col md="5">
            <h4 class="page-title mb-1">FF Client Exp Dashboard</h4>
          </b-col>
          <b-col md="3">
            <date-range-picker
            class="mb-1"
              :opens="openLeft"
              :always-show-calendars="showCal"
              v-model="dateRange"
              :startDate="startDate"
              :endDate="endDate"
              :locale-data="locale"
              @update="viewTypeSize"
            >
            </date-range-picker>
          </b-col>
          <b-col md="3">
             <!-- &&  $sessionsStorage.get('nameUser') != 'Bhavneesh' -->
            <model-list-select
              class="mb-1"
              :list="clientMaster"
              id="clientNamenew"
              v-model="clientIdFilter"
              option-value="clientId"
              option-text="clientName"
              placeholder="Select  Client Name"
              :isDisabled="$sessionsStorage.get('designation') != 'Admin'? true: false"
              @input="viewTypeSize"
            ></model-list-select>
          </b-col>
             <b-col md="3">
                <label>POD</label>
                <model-list-select
                  @input="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
                    viewTypeSize();
                  "
                  @searchchange="
                    getLocationList($event, 'Sea_Port_NonIndia', 'getPortDischargeList');
                  "
                  :list="getPortDischargeList.length>0?getPortDischargeList:$store.getters['common/getAllPODList']"
                  v-model="PODfilter"
                  option-value="pickupId"
                  option-text="pickupLocation"
                  placeholder="Select POD"
                ></model-list-select>
              </b-col>
          <b-col md="1" class="text-right">
            <b-button class="mb-1" variant="outline-info" @click="getPDF"><i class="fa fa-cloud-download" aria-hidden="true"></i>
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <div class="gutr mt-3">
          <div class="row" v-if="TotalShippedContEXP !=0 || Tot20STDTUESTypeCount !=0 || Tot40STDTUESTypeCount != 0">

            <div class="col-xl-3 col-sm-6 grid-margin stretch-card mb-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <div class="row">
                        <div class="col-md-12">
                          <h6 class="card-title">TOT. CONTAINERS TEUS EXP</h6>
                          <div class="fluid-container">
                            <table class="table mb-0">
                              <tbody>
                                <tr>
                                  <td>Execution</td>
                                  <td>CONTAINERS</td>
                                  <td>TEUS</td>
                                </tr>
                                <tr>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{ totalExec }}</h4></td>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{ TotalShippedContEXP }}</h4></td>
                                  <td><h4 class="card-title font-weight-bold mb-0">{{TotalShippedContEXPTUES}}</h4></td>
                                  <!-- <td><h4 class="card-title font-weight-bold mb-0">{{ Tot20STDTUESTypeCount+Tot40STDTUESTypeCount }}</h4></td> -->
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mt-2">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOT. TYPE OF CONTAINER EXP</h6>
                      <div class="fluid-container">
                        <span class="card-title font-weight-bold mb-0">
                          20  = {{ Tot20STDTypeCount }}
                        </span><br/>
                        <span class="card-title font-weight-bold mb-0">
                          40  = {{ Tot40STDTypeCount }}
                        </span><br/>
                        <span class="card-title font-weight-bold mb-0">
                          LCL CONTAINERS : {{ TotLCL_Container_TotalShippedCont }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mt-2 ">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOTAL TEUS </h6>
                      <div class="fluid-container">
                        <span class="font-weight-bold mb-0">
                          {{ Tot20STDTypeCount }} * 1 = {{ Tot20STDTUESTypeCount }}
                        </span><br/>
                        <span class="font-weight-bold mb-0">
                          {{ Tot40STDTypeCount }} * 2 = {{ Tot40STDTUESTypeCount }}
                        </span> &nbsp;&nbsp; 
                        <span class="card-title font-weight-bold mb-0">
                         <b-badge variant="primary"> {{ Tot20STDTUESTypeCount }} </b-badge>+ <b-badge variant="primary">{{ Tot40STDTUESTypeCount }}</b-badge> =  <b-badge variant="danger">{{ Tot20STDTUESTypeCount+Tot40STDTUESTypeCount }}</b-badge>
                        </span><br/>
                        <span class="font-weight-bold mb-0">
                          LCL CONTAINERS : {{ TotLCLTUES_Container_TotalShippedCont }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <md-icon class="md-size-1x">import_export</md-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div  v-if="totalExec != '0'" class="col-xl-5 col-md-6 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">TOTAL CONTAINER TYPE EXP MODULES</h6>
                      <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="showgraphsContainer == true"
                            type="pie"
                            class="mt-3"
                            width="530"
                            :options="chartOptions"
                            :series="series"
                          ></apexchart>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="topShippingLineContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP SLINE WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 7 (SHIPPING LINE Line)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          <tr>
                            <th>SLINE</th>
                            <th>CONTAINERS</th>
                            <th>TEUS</th>
                          </tr>
                          <tbody>
                            <tr
                              v-for="(item3, index) in topShippingLineContainerExportData"
                              :key="index"
                            >
                           
                              <td class="pl-0" v-if="index<7" @click="getSlineClientBasedGraph(item3.shippingLine,clientIdFilter,item3.shippingId)">{{ item3.shippingLine }}</td>
                              <td class="pr-0" v-if="index<7">
                                <b-badge variant="primary">{{
                                  item3.ContainerCount
                                }}</b-badge>
                              </td>
                              <td class="pr-0" v-if="index<7">
                                    <b-badge variant="danger"
                                    v-b-tooltip.hover 
                                    :title="'20` = '+item3.TUESSLine_Tot20STDTypeCount+' , 40` = '+item3.TUESSLine_Tot40STDTypeCount"><b>{{
                                      parseInt(item3.TUESSLine_Tot20STDTypeCount)+parseInt(item3.TUESSLine_Tot40STDTypeCount)
                                    }}</b></b-badge>
                                  </td>
                            </tr>
                            </tbody>
                        </table>
                        <b-collapse id="collapse-SLine" v-model="slinevisible" class="mt-2">
                          <table class="table mb-0">
                              
                            <tbody>
                                <tr style="color:#fff">
                                  <th>SLINE</th>
                                  <th>CONTAINERS</th>
                                  <th>TEUS</th>
                                </tr>
                                <tr
                                  v-for="(item3, index) in topShippingLineContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0"  v-if="index>=7" @click="getSlineClientBasedGraph(item3.shippingLine,clientIdFilter,item3.shippingId)">{{ item3.shippingLine }}</td>
                                  <td class="pr-0"  v-if="index>=7">
                                    <b-badge variant="primary">{{
                                      item3.ContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=7">
                                    <b-badge variant="danger"
                                    v-b-tooltip.hover 
                                    :title="'20` = '+item3.TUESSLine_Tot20STDTypeCount+' , 40` = '+item3.TUESSLine_Tot40STDTypeCount"
                                ><b>{{
                                      parseInt(item3.TUESSLine_Tot20STDTypeCount)+parseInt(item3.TUESSLine_Tot40STDTypeCount)
                                    }}</b></b-badge>
                                    <!-- {{
                                      item3.SlineContainerTues_Count
                                    }} -->
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topShippingLineContainerExportData.length>10"  
                          :class="slinevisible ? null : 'collapsed error'"
                          :aria-expanded="slinevisible ? 'true' : 'false'"
                          aria-controls="collapse-SLine"
                          @click="slinevisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

  <!-- seriesExpSlineClientGraph[0].data.length > 0 || -->
                  <!-- seriesExpSlineClientGraph[1].data.length > 0 ||
                  seriesExpSlineClientGraph[2].data.length > 0 -->
              <div
                v-if="
                  seriesExpSlineClientGraph[0].data.length > 0 ||
                  seriesExpSlineClientGraph[1].data.length > 0
                "
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
                <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>  

                        <h6 class="card-title">TOTAL TEUS EXP MODULES - {{  graphshippingLine }} </h6>
                        <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="
                            DateRangeContexecDataCount.length>0 && (
                              seriesExpSlineClientGraph[0].data.length > 0 ||
                              seriesExpSlineClientGraph[1].data.length > 0 )
                            "
                            type="bar"
                            class="mt-3"
                            height="550"
                            width="1000"
                            :options="chartOptionsExpSlineClientGraph"
                            :series="seriesExpSlineClientGraph"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                    <!-- /.box-header -->
              </div>

<!-- {{getSlineClinteBasedData}} -->

              <div
                v-if="getSlineClinteBasedData.length>0"
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
               <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <table id="shiper" class="table table-bordered" v-if="getSlineClinteBasedData">
                        <thead>
                          <tr>
                            <th>SN.</th>
                            <th>Date Range</th>
                            <th>Sline</th>
                            <th>Execution</th>
                            <th>Containers</th>
                            <th>TEUS</th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            v-for="(item1, index) in getSlineClinteBasedData"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ item1.fromDate+" / "+item1.toDate }}</td>
                            <td>{{ item1.shippingLine }}</td>
                            <td>{{ item1.allModuleIdCount }}</td>
                            <td>{{ item1.ContainerCount }}</td>
                            <td>{{ item1.alltues_count }}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>
              </div>

              <div
                v-if="getClinteBasedData.length>0"
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
               <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <!-- {{getClinteBasedData}} -->
                      <table id="shiper" class="table table-bordered" v-if="getClinteBasedData">
                        <thead>
                          <tr>
                            <th>SN.</th>
                            <th>Date Range</th>
                            <!-- <th>Client</th> -->
                            <th>Execution</th>
                            <th>Containers</th>
                            <th>TEUS</th>
                          </tr>
                        </thead>
                          
                        <tbody>
                          <tr
                            v-for="(item1, index) in getClinteBasedData"
                            :key="index"
                          >
                            <td>{{ index + 1 }}</td>
                            <td>{{ item1.fromDate+" / "+item1.toDate }}</td>
                            <!-- <td>{{ item1.clientName }}</td> -->
                            <td>{{ item1.allModuleIdCount }}</td>
                            <td>{{ item1.ContainerCount }}</td>
                            <td>{{ item1.alltues_count }}</td>
                          </tr>
                        </tbody>
                      </table>

                    </div>
                  </div>
                </div>

                
              <div
                v-if="
                  seriesExpClientGraph[0].data.length > 0 ||
                  seriesExpClientGraph[1].data.length > 0
                "
                class="col-xl-12 col-md-12 grid-margin stretch-card mt-2"
              >
                <div class="card card-statistics formCardDash">
                  <div class="card-body">
                    <div class="d-flex justify-content-between flex-wrap">
                      <div>
                        <h6 class="card-title">TOTAL TEUS EXP MODULES - {{ graphClinetName }} </h6>
                        <div class="fluid-container"></div>
                        <div id="chart">
                          <apexchart
                            v-if="(
                              seriesExpClientGraph[0].data.length > 0 ||
                              seriesExpClientGraph[1].data.length > 0)
                            "
                            type="bar"
                            class="mt-3"
                            height="550"
                            width="1000"
                            :options="chartOptionsExpClientGraph"
                            :series="seriesExpClientGraph"
                          ></apexchart>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                    <!-- /.box-header -->
              </div>

              </div>

            <!-- <div v-if="topClientWiseContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP CLIENT WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (CLIENT)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          <tr>
                            <th>CLIENT</th>
                            <th>CONTAINERS</th>
                            <th>TEUS</th>
                          </tr>
                          <tbody>
                            <tr
                              v-for="(item3, index) in topClientWiseContainerExportData"
                              :key="index"
                            >
                            
                              <td class="pl-0" v-if="index<10" @click="ViewClientDetails(item3.clientId)">{{ item3.ClientList }}</td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="primary">{{
                                  item3.ClientContainerCount
                                }}</b-badge>
                                
                              </td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="danger" 
                                ><b>{{
                                  item3.ContainerTues_Count
                                }}</b></b-badge>
                                
                              </td>
                            </tr>
                          </tbody>
                        </table>
                          <b-collapse id="collapse-ClientList" v-model="clientvisible" class="mt-2">
                          <table class="table mb-0">
                                <tr style="color:#fff">
                                  <th>CLIENT</th>
                                  <th>CONTAINERS</th>
                                  <th>TEUS</th>
                                </tr>
                            <tbody>
                                <tr
                                  v-for="(item3, index) in topClientWiseContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0"  v-if="index>=10" @click="ViewClientDetails(item3.clientId)">{{ item3.ClientList }}</td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="primary">{{
                                      item3.ClientContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="danger" 
                                      ><b>{{
                                      item3.ContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topClientWiseContainerExportData.length>10"  
                          :class="clientvisible ? null : 'collapsed error'"
                          :aria-expanded="clientvisible ? 'true' : 'false'"
                          aria-controls="collapse-ClientList"
                          @click="clientvisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div> -->

            <div v-if="topBranchWiseContainerExportData > '0'" class="col-xl-4 col-md-6 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP BRANCH WISE CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (BRANCH)</p>
                      <div class="fluid-container">
                        <table class="table mb-0">
                          
                          <tbody>
                            <tr>
                              <th>BRANCH</th>
                              <th>CONTAINERS</th>
                              <th>TEUS</th>
                            </tr>
                            <tr
                              v-for="(item3, index) in topBranchWiseContainerExportData"
                              :key="index"
                            >
                              <td class="pl-0" v-if="index<10">{{ item3.BranchWise }}</td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="primary">{{
                                  item3.BranchContainerCount
                                }}</b-badge>
                              </td>
                              <td class="pr-0" v-if="index<10">
                                <b-badge variant="danger"><b>{{
                                  item3.BranchContainerTues_Count
                                }}</b></b-badge>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <b-collapse id="collapse-branchvisible" v-model="branchvisible" class="mt-2">
                          <table class="table mb-0">
                             <tr style="color:#fff">
                                <th>BRANCH</th>
                                <th>CONTAINERS</th>
                                <th>TEUS</th>
                              </tr>
                            <tbody>
                                <tr
                                  v-for="(item3, index) in topBranchWiseContainerExportData"
                                  :key="index"
                                >
                                  <td class="pl-0" v-if="index>=10">{{ item3.BranchWise }}</td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="primary">{{
                                      item3.BranchContainerCount
                                    }}</b-badge>
                                  </td>
                                  <td class="pr-0" v-if="index>=10">
                                    <b-badge variant="danger"><b>{{
                                      item3.BranchContainerTues_Count
                                    }}</b></b-badge>
                                  </td>
                                </tr>
                              </tbody>
                          </table>
                        </b-collapse>
                        <span v-if="topBranchWiseContainerExportData.length>10"  
                          :class="branchvisible ? null : 'collapsed error'"
                          :aria-expanded="branchvisible ? 'true' : 'false'"
                          aria-controls="collapse-branchvisible"
                          @click="branchvisibleFun">VIEW MORE</span>
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="top10ContainerTypeExportData.length > '0' && top10BranchesExportData.length>0" class="col-xl-8 col-md-8 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP Client WISE TYPE BASED CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (Branch)</p>
                      <div class="fluid-container"  style="overflow-x:auto;">
                        
                        <span v-html="totalHtmlCont" >
                        {{this.totalHtmlCont}}
                        <!-- totalSlineHtmlCont -->
                        </span>
                        
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- {{top10SlinesExportData.length}} -->
            <div v-if="top10ContainerTypeExportData.length > '0' && top10SlinesExportData.length>0" class="col-xl-8 col-md-8 grid-margin stretch-card mt-2">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <div class="d-flex justify-content-between flex-wrap">
                    <div>
                      <h6 class="card-title">MOST EXP SLINE WISE TYPE BASED CONTAINERS</h6>
                      <p class="card-description text-muted">TOP 10 (SLINE)</p>
                      <div class="fluid-container"  style="overflow-x:auto;">
                        
                        <span v-html="totalSlineHtmlCont" >
                        {{this.totalSlineHtmlCont}}
                        <!--  -->
                        </span>
                        
                      </div>
                        
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-xl-12 col-sm-12 grid-margin stretch-card mb-2 text-center">
              <div class="card card-statistics formCardDash">
                <div class="card-body">
                  <!-- <div class="d-flex justify-content-between flex-wrap"> -->
                    <div class="row">
                      <div class="col-xl-4 col-sm-12 grid-margin">

                      </div>
                      <div class="col-xl-4 col-sm-12 grid-margin">
                          <center><h6 class="card-title error text-center">Data Not Found !</h6></center>
                      </div>
                      <div class="col-xl-4 col-sm-12 grid-margin">

                      </div>
                    </div>
                    
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row gutr"></div>
      </b-card>
      <b-card v-else class="mainCardBG">
        <b-navbar toggleable="lg" type="dark" variant="info">
          <b-navbar-brand v-if="showDash == false">
            <h4 class="page-title" v-if="employeeName != ''">
              Welcome <small>{{ employeeName }}</small>
            </h4>
          </b-navbar-brand>
        </b-navbar>
      </b-card>
    </section>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
    ></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
// import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DateRangePicker from "vue2-daterange-picker";
import DashboardService from "../../services/DashboardService.js";
import {
  globalPermissionStatus,
  GlobalGetLocation,
  lastVisitPage,
} from "../../helper/collection";
export default {
  beforeMount() {
     this.$store.dispatch(
        "common/setAllPODList",
        JSON.stringify({
          itemCode: "PODList",
           type:'Normal',
        Territory:'',
        })
      );
    this.getCurrentLastDate();
    lastVisitPage(this.$router.history.current.fullPath);
    if (globalPermissionStatus("Sea Freight")) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/ffexpdash/ffExpCleintdash"
      );
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewTypeSize("0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    // if (
    //   this.$sessionsStorage.get("loginId") != undefined &&
    //   this.$sessionsStorage.get("loginId") != ""
    // ) {
    //   if (
    //     (this.$sessionsStorage.get("designation") == "Admin" &&
    //       this.$sessionsStorage.get("nameUser") == "Bhavneesh") ||
    //     (this.$sessionsStorage.get("designation") == "Admin" &&
    //       this.$sessionsStorage.get("nameUser") == "Aaryav")
    //   ) {
    //     this.$store.dispatch("setCurrentRoute", "/ffexpdash/ffExpCleintdash");
    //     this.viewTypeSize("0", "1", "1");
    //   } else {
    //     this.$router.push({
    //       path: "/ffseaExpdashboard",
    //     });
    //   }
    // } else {
    //   this.$router.push({
    //     path: "/Login/",
    //   });
    // }
  },
  mounted() {},

  beforeDestroy() {},
  destroyed() {},
  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,
  },
  computed: {},
  data() {
    return {
      getPortDischargeList: [],
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      clientMaster: [],
      clientIdFilter: this.$sessionsStorage.get("ffexpclientDash"),
      PODfilter:"",
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      openLeft: "left",
      showCal: false,
      showDash: true,
      slinevisible:false,
      clientvisible:false,
      branchvisible:false,
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      showgraphsContainer: false,
      showgraphsRev: false,
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      employeeName: "",
      employeeLoc: "",
      cunvertUSD: "75",
      calculatGraphRevenue: "75",
      totalExec: "",
      TotalShippedContEXPTUES:0,
      totalContainerShiped: "",
      TotalShippedContEXP: "",
      Tot20STDTypeCount: "",
      Tot40STDTypeCount: "",
      TotLCL_Container_TotalShippedCont: "",
      Tot20STDTUESTypeCount: "",
      Tot40STDTUESTypeCount: "",
      TotLCLTUES_Container_TotalShippedCont: "",
      totalHtmlCont:"",
      totalSlineHtmlCont:'',
      Comb_BranchCont:"",
      ContainertTypetemp_arr:'',

      CustomRevenue: "",
      TPTRevenue: "",
      totalTallyAddedRevenueSum: "",
      AEDRates: 20.42,
      JODRates: 105.75,
      CADRates: 55.21,
      ZARRates: 4.48,
      GBPRates: 94.16,
      EURORates: 85.62,
      USDRates: 74.98,
      backendAmountUSD: "",
      topShippingLineContainerExportData:[],
      topClientWiseContainerExportData:[],
      topBranchWiseContainerExportData:[],
      top10ContainerTypeExportData:[],
      top10BranchWiseBaseContainerTyperow:[],
      topBranchContainerTypeCountData:[],
      top10BranchesExportData:[],
      top10SlinesExportData:[],
      allContMyAll:[],
      totRowContCount:'0',
      totColContCount:'0',
      totTuesContCount:'0',

      isLoading: false,
      series: [],
      chartOptions: {
        plotOptions: {
          pie: {
            // customScale: 1.0
            // size: 200
          },
        },
        chart: {
          width: 200,
          type: "pie",
        },
        labels: [],

        responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: 200,
              },
              legend: {
                position: "bottom",
              },
            },
          },
        ],
      },

      seriesClientRev: [
        {
          name: "Ammount",
          data: [],
        },
      ],
      chartOptionsShippingLine: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsClientReven: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -30,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "Ammount (INR)",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },

      chartOptionsConBar: {
        chart: {
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: true,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                position: "bottom",
                offsetX: -10,
                offsetY: 0,
              },
            },
          },
        ],
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        xaxis: {
          categories: [],
        },
        legend: {
          position: "bottom",
          offsetY: 10,
        },
        fill: {
          opacity: 1,
        },
      },
      seriesExCom: [
        {
          name: "No.of Times Used",
          data: [],
        },
      ],
      chartOptionsExCom: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "off",
        },
        yaxis: {
          title: {
            text: "No. of Times Used",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      seriesShipBar: [
        {
          name: "No.of Container Shiped",
          data: [],
        },
      ],
      chartOptionsShipBar: {
        annotations: {},
        chart: {
          height: 350,
          type: "bar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            columnWidth: "50%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
        },
        stroke: {
          width: 2,
        },

        grid: {
          row: {
            colors: ["#fff", "#f2f2f2"],
          },
        },
        xaxis: {
          labels: {
            rotate: -35,
          },
          categories: [],
          tickPlacement: "on",
        },
        yaxis: {
          title: {
            text: "No. of Container Shipped",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.25,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.85,
            opacityTo: 0.85,
            stops: [50, 0, 100],
          },
        },
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
      DateRangeContexecDataCount: [],
      getSlineClinteBasedData:[],
      getClinteBasedData:[],
      seriesExpSlineClientGraph: [
        // {
        //   name: "Assignment Execution",
        //   data: []
        // },
        {
          name: "Containers",
          data: []
        },
        {
          name: "TEUS",
          data: []
        }
      ],
      chartOptionsExpClientGraph: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          }
        },
        chart: {
          height: 350,
          type: "bar",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5]
        },
        title: {
          text: "Export SLine Client wise Execution Containers & TEUS Trends by Month",
          align: "left"
        },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val;
                }
              }
            }
          ]
        }
      },
      seriesExpClientGraph: [
        // {
        //   name: "Assignment Execution",
        //   data: []
        // },
        {
          name: "Containers",
          data: []
        },
        {
          name: "TEUS",
          data: []
        }
      ],
      chartOptionsExpSlineClientGraph: {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          }
        },
        chart: {
          height: 350,
          type: "bar",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5]
        },
        title: {
          text: "Export SLine Client wise Execution Containers & TEUS Trends by Month",
          align: "left"
        },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val;
                }
              }
            }
          ]
        }
      },
      graphshippingLine:null,
      graphClinetName:null,
    };
  },
  methods: {
     getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type,
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function (error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
              this.getPortDischargeList = result;
            }
          }
        });
        console.log("self[vmodelArray]=>",self)
        
      }
    },
    ClientDetails(ClientID){
      // console.log("Happy Singh ClientID=>",ClientID);
    },
    ViewClientDetails(ClientID){
      // console.log("ViewClientDetails Happy Singh ClientID=>",ClientID);
    },
    branchvisibleFun(){
      if(this.topBranchWiseContainerExportData.length>10){
        if(this.branchvisible == true){
          this.branchvisible = false;
        }else{
          this.branchvisible = true;
        }
      }
    },
    getSlineClientBasedGraph(shippingLine,clientIdFilter,shippingId){
      console.log("clientIdFilter=>",clientIdFilter)
      console.log("shippingId=>",shippingId);
      this.DateRangeContexecDataCount = [];
      this.seriesExpSlineClientGraph[0].data = [];
      this.seriesExpSlineClientGraph[1].data = [];
      this.graphshippingLine = shippingLine;
      // this.seriesExpSlineClientGraph[2].data = [];
      this.chartOptionsExpSlineClientGraph.xaxis.categories = [];
      let payload = {
        itemCode: "getSlineClinteBasedGraphData",
        dateRange: this.dateRange,
        clientIdFilter:clientIdFilter,
        shippingIdFilter:shippingId,
        PODfilter:this.PODfilter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

            if (data.DateRangeContexecDataCount.length > 0) {
              this.DateRangeContexecDataCount = data.DateRangeContexecDataCount;
              if (
                this.dateRange.startDate != "" ||
                this.clientIdFilter != "" ||
                shippingId != "" ||
                data.DaysDiff > 0 ||
                data.MonthDiff > 0
              ) {
                this.seriesExpSlineClientGraph[0].data = [];
                this.seriesExpSlineClientGraph[1].data = [];
                // this.seriesExpSlineClientGraph[2].data = [];
                this.chartOptionsExpSlineClientGraph.xaxis.categories = [];
                this.DateRangeContexecDataCount.forEach(element => {
                  let date = new Date(element.fromDate); // 2020-06-21
                  // let longMonth = date.toLocaleString('en-us', { month: 'long' }); /* June */
                  let shortMonth = date.toLocaleString("en-us", {
                    month: "short"
                  }); /* June */
                  
                  let TotFFSeaExportExe = element.TotFFSeaExportExe
                    ? parseInt(element.TotFFSeaExportExe)
                    : 0;
                    
                  let TotFFSeaExportExeCont = element.TotFFSeaExportExeCont
                    ? parseInt(element.TotFFSeaExportExeCont)
                    : 0;
                  let TotFFSeaExportExeContTUES = element.TotFFSeaExportExeContTUES
                    ? parseInt(element.TotFFSeaExportExeContTUES)
                    : 0;
                  this.seriesExpSlineClientGraph[0].data.push(TotFFSeaExportExeCont+" Cont");
                  this.seriesExpSlineClientGraph[1].data.push(TotFFSeaExportExeContTUES+" TUES");
                  // this.seriesExpSlineClientGraph[2].data.push(TotFFSeaExportExeContTUES);
                  // this.seriesExpSlineClientGraph[0].data.push(TotFFSeaExportExe);
                  // this.seriesExpSlineClientGraph[1].data.push(TotFFSeaExportExeCont);
                  // this.seriesExpSlineClientGraph[2].data.push(TotFFSeaExportExeContTUES);
                  this.chartOptionsExpSlineClientGraph.xaxis.categories.push(shortMonth);
                });
              }
            } else {
              this.DateRangeContexecDataCount = [];
            }
        })
        .catch((error) => {
          console.log("Catch on getSlineClientBasedGraph Error: ", error);
        });
    
   

    },
    clientvisibleFun(){
      if(this.topClientWiseContainerExportData.length>10){
        if(this.clientvisible == true){
          this.clientvisible = false;
        }else{
          this.clientvisible = true;
        }
      }
    },
    slinevisibleFun(){
      if(this.topShippingLineContainerExportData.length>10){
        if(this.slinevisible == true){
          this.slinevisible = false;
        }else{
          this.slinevisible = true;
        }
      }
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };this.getPortDischargeList = this.$store.getters["common/getAllPODList"].length>0?this.$store.getters["common/getAllPODList"]:[];
    },
    gotToFullClientReports() {
      this.$router.push({
        path: "/dashboard/clientProfile",
      });
    },
    changeNumberFormat(num) {
      if (num > 9999999) {
        return Math.abs(num) > 9999999
          ? Math.sign(num) * (Math.abs(num) / 10000000).toFixed(2) + " Crore"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 99999) {
        return Math.abs(num) > 99999
          ? Math.sign(num) * (Math.abs(num) / 100000).toFixed(2) + " Lakhs"
          : Math.sign(num) * Math.abs(num);
      } else if (num > 999) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + " Thousand"
          : Math.sign(num) * Math.abs(num);
      } else {
        return num;
      }
    },

    convertCurrency(ID) {
      if (ID == "USD") {
        this.finalAmountUSD =
          parseInt(this.backendAmountUSD) * parseInt(this.cunvertUSD) + " INR";
      }
      if (this.cunvertUSD == "") {
        this.finalAmountUSD = this.backendAmountUSD;
      }
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    previousPage() {
      window.history.go(-1);
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewTypeSize("0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set(
        "oldRoute",
        this.$router.history.current.fullPath
      );
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewTypeSize("0", CURRENT, "2", event);
    },
    viewTypeSize() {
      this.chartOptionsExpSlineClientGraph= {
        plotOptions: {
          line: {
            // customScale: 1.0
            // size: 200
          }
        },
        chart: {
          height: 350,
          type: "bar",
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: true
        },
        stroke: {
          width: [5, 7, 5],
          curve: "straight",
          dashArray: [0, 8, 5]
        },
        title: {
          text: "Export SLine Client wise Execution Containers & TEUS Trends by Month",
          align: "left"
        },
        legend: {
          tooltipHoverFormatter: function(val, opts) {
            return (
              val +
              " - " +
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
              ""
            );
          }
        },
        markers: {
          size: 0,
          hover: {
            sizeOffset: 6
          }
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: [
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val + " ";
                }
              }
            },
            {
              title: {
                formatter: function(val) {
                  return val;
                }
              }
            }
          ]
        }
      };
      this.seriesExpSlineClientGraph= [
        // {
        //   name: "Assignment Execution",
        //   data: []
        // },
        {
          name: "Containers",
          data: []
        },
        {
          name: "TEUS",
          data: []
        }
      ];
      this.isLoading = true;
      this.showgraphsRev = false;
      this.showDash = true;
      this.slinevisible=false,
      this.clientvisible=false,
      this.branchvisible=false,
      this.chartOptionsClientReven.xaxis.categories = [];
      this.chartOptions.labels = [];
      this.topShippingLineContainerExportData = [];
      this.topClientWiseContainerExportData = [];
      this.topBranchWiseContainerExportData = [];
      this.top10ContainerTypeExportData = [];
      this.top10BranchWiseBaseContainerTyperow = [];
      this.topBranchContainerTypeCountData=[];
      this.allContMyAll = [];
      this.top10BranchesExportData = [];
      this.top10SlinesExportData=[];
      this.series = [];
      this.seriesClientRev[0].data = [];
      this.chartOptionsShipBar.xaxis.categories = [];
      this.totalHtmlCont = [];
      this.totalSlineHtmlCont=[];
      this.Comb_BranchCont = [];
      this.ContainertTypetemp_arr = [];
      // this.clientMaster = [];

      this.totRowContCount='0';
      this.totColContCount='0';
      this.totTuesContCount='0';

      this.graphClinetName="";
      // alert(this.clientIdFilter)

      let CLientFilter = this.clientMaster.filter((val,key)=>{
        return val.clientId==this.clientIdFilter;
      });
      // alert(CLientFilter.length>0)
      if(CLientFilter.length>0){
        this.graphClinetName=CLientFilter[0].clientName;
      }

      let type_Size = {
        ClientFFDASH: "ClientFFDASH",
        dateRange: this.dateRange,
        clientIdFilter:this.clientIdFilter,
        PODfilter:this.PODfilter,
      };
      this.getSlineClinteBased();
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Common/getFFSeaExpDashClientSline.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // console.log("Priyanshu Singh=>",data);
            if (data.msg == "Invalid Token") {
              this.$sessionsStorage.set("loginId", "");
              this.$store.dispatch("setCurrentRoute", "/Login/");
              this.$router.push({
                path: "/Login/",
              });
            } else {
              // if()
              // console.log("Priyanshu Singh=>",data);
              
              if (data.clientMaster.length > 0) {
                  this.clientMaster = data.clientMaster;
              }
              
              if (data.topShippingLineContainerExportData.length > 0) {
                this.topShippingLineContainerExportData = data.topShippingLineContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.ShippingLineExport;
                if(data.ContainerCount !=''&&data.ContainerCount !='undefined'&&data.ContainerCount !='null'&&data.ContainerCount !=undefined&&data.ContainerCount !=null){
                  this.seriesExCom[0].data = data.ContainerCount;
                }
              }

              if (data.topClientWiseContainerExportData.length > 0) {
                this.topClientWiseContainerExportData = data.topClientWiseContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.ClientWiseExport;
                if(data.ClientContainerCount !=''&&data.ClientContainerCount !='undefined'&&data.ClientContainerCount !='null'&&data.ClientContainerCount !=undefined&&data.ClientContainerCount !=null){
                  this.seriesExCom[0].data = data.ClientContainerCount;
                }
              }

              if (data.topBranchWiseContainerExportData.length > 0) {
                this.topBranchWiseContainerExportData = data.topBranchWiseContainerExportData;
                this.chartOptionsExCom.xaxis.categories = data.BranchWiseExport;
                if(data.BranchContainerCount !=''&&data.BranchContainerCount !='undefined'&&data.BranchContainerCount !='null'&&data.BranchContainerCount !=undefined&&data.BranchContainerCount !=null){
                  this.seriesExCom[0].data = data.BranchContainerCount;
                }
              }
              
              if (data.top10ContainerTypeExportData.length > 0) {
                this.top10ContainerTypeExportData = data.top10ContainerTypeExportData;
              }
              // console.log("data.top10BranchWiseBaseContainerTyperow=>",data.userDetails)
              if (data.top10BranchWiseBaseContainerTyperow.length > 0) {
                this.top10BranchWiseBaseContainerTyperow = data.top10BranchWiseBaseContainerTyperow;
              }
              
              if(data.totalHtmlCont !=''){
                this.totalHtmlCont = data.totalHtmlCont;
              }
              if(data.totalSlineHtmlCont !=''){
                this.totalSlineHtmlCont = data.totalSlineHtmlCont;
              }
             
              if (data.top10BranchesExportData.length > 0) {
                this.top10BranchesExportData = data.top10BranchesExportData;
              }
              if (data.top10SlinesExportData.length > 0) {
                this.top10SlinesExportData = data.top10SlinesExportData;
              }
              // console.log("data.userDetails=>",data.userDetails)
              if (data.userDetails.length > 0) {
                
                if (data.userDetails[0].dashBoardPermission == "Yes") {
                  this.showDash = true;
                } else {
                  this.showDash = true;
                  if (data.userDetails[0].type == "1") {
                    this.employeeName =
                      data.userDetails[0].employeeName.toUpperCase();
                    this.employeeLoc =
                      data.userDetails[0].employeeLoc.toUpperCase();
                  }
                }
              }
              this.totalExec = data.totalExec;
              this.TotalShippedContEXPTUES = data.TotalShippedContEXPTUES;
              this.TotalShippedContEXP = data.TotalShippedContEXP;

              this.Tot20STDTypeCount = data.TotalShippedCont20EXP;
              this.Tot40STDTypeCount = data.TotalShippedCont40EXP;
              this.TotLCL_Container_TotalShippedCont = data.TotalShippedContLCLEXP;

              this.Tot20STDTUESTypeCount = parseInt(data.TotalShippedCont20EXP)*1;
              this.Tot40STDTUESTypeCount = parseInt(data.TotalShippedCont40EXP)*2;
              this.TotLCLTUES_Container_TotalShippedCont = data.TotalShippedContLCLEXP;
              // this.Tot20STDTypeCount = data.Tot20STDTypeCount;
              // this.Tot40STDTypeCount = data.Tot40STDTypeCount;
              // this.TotLCL_Container_TotalShippedCont = data.TotLCL_Container_TotalShippedCont;

              // this.Tot20STDTUESTypeCount = parseInt(data.Tot20STDTypeCount)*1;
              // this.Tot40STDTUESTypeCount = parseInt(data.Tot40STDTypeCount)*2;
              // this.TotLCLTUES_Container_TotalShippedCont = data.TotLCL_Container_TotalShippedCont;
              // this.totalTallyAddedRevenueSum = this.changeNumberFormat(parseFloat( data.totalTallyAddedRevenueSum)) ;
              this.totalTallyAddedRevenueSum =
                this.changeNumberFormat(
                  parseFloat(data.totalTallyAddedRevenueSum)
                ) +
                " + ₹" +
                this.changeNumberFormat(parseFloat(data.total_GstVal)) +
                " = ₹" +
                this.changeNumberFormat(
                  parseFloat(data.total_GstRevenueSumVal)
                );

              // top Container Type chart

              this.series = data.TotalExecutionChartData;
              for (
                let q = 0;
                q < data.TotalExecutionChartLabelData.length;
                q++
              ) {
                this.chartOptions.labels.push(
                  data.TotalExecutionChartLabelData[q]
                );
              }

              this.showgraphsContainer = true;
              this.showgraphsRev = true;

              this.isLoading = false;
            }
          }
        })
        .catch((error) => {});
    },
    getSlineClinteBased(){
      this.DateRangeContexecDataCount = [];
      this.getSlineClinteBasedData = [];
      let payload = {
        itemCode: "getSlineClinteBasedData",
        dateRange: this.dateRange,
        clientIdFilter:this.clientIdFilter,
        PODfilter:this.PODfilter,
      };
      this.getClinteBased();
      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

            if (data.getSlineClinteBasedData.length > 0) {
              let getSlineClinteBased = data.getSlineClinteBasedData;
              this.getSlineClinteBasedData = [];
              getSlineClinteBased.forEach((item)=>{

                this.getSlineClinteBasedData.push(...item.getSlineClinteBased);
              })
              // this.getSlineClinteBasedData = data.getSlineClinteBasedData;
            } else {
              this.getSlineClinteBasedData = [];
            }
        })
        .catch((error) => {
          console.log("Catch on getSlineClinteBasedData Error: ", error);
        });
    
   

    },
    getClinteBased(){
      this.seriesExpClientGraph[0].data = [];
      this.seriesExpClientGraph[1].data = [];
      // this.seriesExpClientGraph[2].data = [];
      this.chartOptionsExpClientGraph.xaxis.categories = [];
      this.getClinteBasedData = [];
      let payload = {
        itemCode: "getClinteBasedData",
        dateRange: this.dateRange,
        clientIdFilter:this.clientIdFilter,
        PODfilter:this.PODfilter,
      };

      DashboardService.getAllOptDashboard(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.isLoading = false;

            if (data.getClinteBasedData.length > 0) {
              let getClinteBased = data.getClinteBasedData;
              this.getClinteBasedData = [];
              getClinteBased.forEach((item)=>{

                this.getClinteBasedData.push(...item.getClinteBased);
              });
              if (data.getClinteBasedData.length > 0) {
              if (
                this.dateRange.startDate != "" ||
                this.clientIdFilter != "" ||
                data.DaysDiff > 0 ||
                data.MonthDiff > 0
              ) {
                this.seriesExpClientGraph[0].data = [];
                this.seriesExpClientGraph[1].data = [];
                // this.seriesExpClientGraph[2].data = [];
                this.chartOptionsExpClientGraph.xaxis.categories = [];
                this.getClinteBasedData.forEach(element => {
                  let date = new Date(element.fromDate); // 2020-06-21
                  // let longMonth = date.toLocaleString('en-us', { month: 'long' }); /* June */
                  let shortMonth = date.toLocaleString("en-us", {
                    month: "short"
                  }); /* June */
                  
                  let TotFFSeaExportExe = element.totalExec
                    ? parseInt(element.totalExec)
                    : 0;
                    
                  let TotFFSeaExportExeCont = element.ContainerCount
                    ? parseInt(element.ContainerCount)
                    : 0;
                  let TotFFSeaExportExeContTUES = element.alltues_count
                    ? parseInt(element.alltues_count)
                    : 0;
                  this.seriesExpClientGraph[0].data.push(TotFFSeaExportExeCont+" Cont");
                  this.seriesExpClientGraph[1].data.push(TotFFSeaExportExeContTUES+" TEUS");
                  // this.seriesExpClientGraph[2].data.push(TotFFSeaExportExeContTUES);
                  // this.seriesExpClientGraph[0].data.push(TotFFSeaExportExe);
                  // this.seriesExpClientGraph[1].data.push(TotFFSeaExportExeCont);
                  // this.seriesExpClientGraph[2].data.push(TotFFSeaExportExeContTUES);
                  this.chartOptionsExpClientGraph.xaxis.categories.push(shortMonth);
                });
                console.log("this.seriesExpClientGraph=>",this.seriesExpClientGraph)
                console.log("this.chartOptionsExpClientGraph=>",this.chartOptionsExpClientGraph)
              }
            } 

              // const combinedData = {};

              // this.getClinteBasedData.forEach(item => {
              //   if (!combinedData[item.clientName]) {
              //     combinedData[item.clientName] = { ...item };
              //   } else {
              //     combinedData[item.clientName].totalExec = String(
              //       parseInt(combinedData[item.clientName].totalExec) + parseInt(item.totalExec)
              //     );
              //     combinedData[item.clientName].ContainerCount = String(
              //       parseInt(combinedData[item.clientName].ContainerCount) + parseInt(item.ContainerCount)
              //     );
              //     combinedData[item.clientName].allModuleIdCount = String(
              //       parseInt(combinedData[item.clientName].allModuleIdCount) + parseInt(item.allModuleIdCount)
              //     );
              //     combinedData[item.clientName].alltues_count = String(
              //       parseInt(combinedData[item.clientName].alltues_count) + parseInt(item.alltues_count)
              //     );
              //   }
              // });

              // const result = Object.values(combinedData);

            // console.log(result);
              // this.getClinteBasedData = data.getClinteBasedData;
            } else {
              this.getClinteBasedData = [];
            }
        })
        .catch((error) => {
          console.log("Catch on getClinteBasedData Error: ", error);
        });
    },
    dashboardReports() {
      this.$router.push({
        path: "/dashboard/dashboardReports",
      });
    },
    randomValue() {
      this.value = Math.random() * this.max;
    },

    // Added By Priyanshu Singh Start
    download() {
      let windowHeight = window.outerHeight;
      let windowWidth = window.outerWidth;

      let pdf = new jsPDF();

      let canvasElement = document.createElement("canvas");
      canvasElement.width = 4000;
      canvasElement.height = 4000;

      html2canvas(this.$refs.Dashboardpdf, {
        canvas: canvasElement,
        width: windowWidth,
        height: windowHeight,
      })
        .then((canvas) => {
          const img = canvas.toDataURL("image/jpeg", 5);
          document.body.appendChild(canvas);
          pdf.addImage(img, "JPEG", 10, 10);
          pdf.save("sample.pdf");

          alert("works");
        })
        .catch((err) => {
          alert("error");
        });
    },
    getPDF() {
      var HTML_Width = $("#Dashboardpdf").width();
      var HTML_Height = $("#Dashboardpdf").height();

      var top_left_margin = 15;
      var PDF_Width = HTML_Width + top_left_margin * 2;
      var PDF_Height = PDF_Width * 1.5 + top_left_margin * 2;
      var canvas_image_width = HTML_Width;
      var canvas_image_height = HTML_Height;

      var totalPDFPages = Math.ceil(HTML_Height / PDF_Height) - 1;

      html2canvas($("#Dashboardpdf")[0], { allowTaint: true }).then(function (
        canvas
      ) {
        canvas.getContext("2d");

        // console.log(canvas.height + "  " + canvas.width);

        var imgData = canvas.toDataURL("image/jpeg", 1.0);
        var pdf = new jsPDF("p", "pt", [PDF_Width, PDF_Height]);
        pdf.addImage(
          imgData,
          "JPG",
          top_left_margin,
          top_left_margin,
          canvas_image_width,
          canvas_image_height
        );

        for (var i = 1; i <= totalPDFPages; i++) {
          pdf.addPage(PDF_Width, PDF_Height);
          pdf.addImage(
            imgData,
            "JPG",
            top_left_margin,
            -(PDF_Height * i) + top_left_margin * 4,
            canvas_image_width,
            canvas_image_height
          );
        }
        var date = new Date();
        var timestamp = date.getTime();

        pdf.save("FF_Client_Dashboard_Document_"+timestamp+".pdf");
      });
    },

    // Added By Priyanshu Singh End
  },
};
</script>

<style scoped>
.topFiveHeight {
  height: 315px !important;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  border-top: 1px solid #ffffff !important;
}
.mainCard {
  display: flex;
  margin-bottom: 2rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 10px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: none !important;
}
.page-header {
  display: flex;
  align-items: center;
  margin: 1.5rem 2rem 1.5rem;
  justify-content: space-between;
  padding: 0;
  border-radius: 3px;
  position: relative;
  min-height: 50px;
  border-bottom: 1px solid #eee !important;
}
.page-title {
  margin: 0;
  font-size: 25px;
  font-weight: 600;
  line-height: 2.5rem;
  position: relative;
  color: #2f2752;
}
.subpage-title {
  font-weight: 300;
  color: #43377b;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.25rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #212529;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.topDivCard {
  margin: 1.5rem 2rem 1.5rem;

  position: relative;

  display: flex;

  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  box-shadow: -8px 12px 18px 0 rgba(25, 42, 70, 0.13);
  border-radius: 3px;
  border: 1px solid transparent;
  margin-bottom: 1.5rem;
  width: 100%;
}
.mb-3 {
  margin: 1.5rem 1rem 1.5rem;
  margin-bottom: 0rem !important;
  font-weight: 600 !important;
  color: #2f2752;
}
.mb-2 {
  margin-bottom: 0 !important;
  font-weight: 700 !important;
}
.mb-4 {
  margin-bottom: -0.5rem !important;
  font-weight: 700 !important;
}
.col-lg-6 {
  width: 49%;
}
.col-lg-4 {
  width: 32.6%;
}
</style>


	


// WEBPACK FOOTER //
// ffClientDashboard .vue?46480215